import moment, {Moment} from 'moment'

export const formatMomentToString = (momentInstance?: Moment | null): string | null =>
  momentInstance ? momentInstance.format('YYYY-MM-DD') : null

export const today = moment()
// past
export const oneWeekAgo = moment().subtract(1, 'w').add(1, 'd')
export const oneYearAgo = moment().subtract(1, 'y').add('1', 'd')
// future
export const fourteenDaysFromToday = moment().add(14, 'd').subtract(1, 'd')
export const thirtyDaysFromToday = moment().add(30, 'd').subtract(1, 'd')
